import { useQuery } from "@apollo/client";

import { GET_ME } from "graphql/query/user-gql";


const useMe = ( fetchPolicy = "cache-only", withStatus = false ) => {

    const { data : { me } = { }, loading, error, refetch } = useQuery( GET_ME, { fetchPolicy } );

    if(withStatus) return { me, loading, error, refetch };

    if(me) return { me, refetch } ;

    return false;
}

export default useMe;
